
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { 
  Plus, 
  Search,
  Music,
  Clock,
  Share2,
  Download
} from "lucide-react";

export const SetsPage = () => {
  const sets = [
    {
      id: 1,
      name: "Summer Vibes Mix",
      duration: "1:45:30",
      genre: "House",
      plays: 1240,
      status: "Published"
    },
    {
      id: 2,
      name: "Deep House Journey",
      duration: "2:15:00",
      genre: "Deep House",
      plays: 890,
      status: "Private"
    },
    {
      id: 3,
      name: "Club Night Set",
      duration: "1:30:00",
      genre: "Tech House",
      plays: 2100,
      status: "Published"
    }
  ];

  const playlists = [
    {
      name: "Club Favorites",
      tracks: 45,
      lastPlayed: "2 days ago"
    },
    {
      name: "Festival Mix",
      tracks: 32,
      lastPlayed: "1 week ago"
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Set Management</h1>
        <Button>
          <Plus className="mr-2 h-4 w-4" />
          Upload New Set
        </Button>
      </div>

      <div className="flex gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input className="pl-8" placeholder="Search your sets..." />
        </div>
        <Button variant="outline">
          <Music className="mr-2 h-4 w-4" />
          Sort by Genre
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <Card className="p-6">
            <h2 className="text-xl font-semibold mb-4">Your Sets</h2>
            <div className="space-y-4">
              {sets.map((set) => (
                <div key={set.id} className="flex items-center justify-between p-4 border rounded-lg">
                  <div className="space-y-1">
                    <h3 className="font-medium">{set.name}</h3>
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <Clock className="h-4 w-4" />
                      {set.duration}
                      <Badge variant="secondary">{set.genre}</Badge>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="text-right">
                      <Badge 
                        variant={set.status === "Published" ? "default" : "secondary"}
                      >
                        {set.status}
                      </Badge>
                      <p className="text-sm text-muted-foreground mt-1">
                        {set.plays} plays
                      </p>
                    </div>
                    <div className="flex gap-2">
                      <Button variant="ghost" size="sm">
                        <Share2 className="h-4 w-4" />
                      </Button>
                      <Button variant="ghost" size="sm">
                        <Download className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>

        <div className="space-y-6">
          <Card className="p-6">
            <h2 className="text-xl font-semibold mb-4">Playlists</h2>
            <div className="space-y-4">
              {playlists.map((playlist, index) => (
                <div key={index} className="flex items-center justify-between p-3 border rounded-lg">
                  <div>
                    <h3 className="font-medium">{playlist.name}</h3>
                    <p className="text-sm text-muted-foreground">
                      {playlist.tracks} tracks
                    </p>
                  </div>
                  <p className="text-sm text-muted-foreground">
                    {playlist.lastPlayed}
                  </p>
                </div>
              ))}
            </div>
          </Card>

          <Card className="p-6">
            <h2 className="text-xl font-semibold mb-4">Storage</h2>
            <div className="space-y-4">
              <div className="w-full bg-secondary rounded-full h-2">
                <div 
                  className="bg-primary rounded-full h-2" 
                  style={{ width: '65%' }}
                />
              </div>
              <p className="text-sm text-muted-foreground">
                13.2 GB of 20 GB used
              </p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};
